<template>
  <combobox ref="primaryInput"
            class="organization-combobox"
            :options="options"
            :label="label"
            :placeholder="placeholder"
            :value="internalValue"
            :errors="internalErrors"
            :disabled="disabled"
            :is-loading="isLoading"
            :internal-search="false"
            @input="onInput"
            @search="onSearch"
            @close="onClose" />
</template>

<script>
import organizationsQuery from '@/api/queries/organizations.graphql';
import ResourceCombobox from '@/mixins/ResourceCombobox';

export default {
  name: 'organization-combobox',
  mixins: [
    ResourceCombobox({
      searchQuery: organizationsQuery,
      unfilteredSort: { field: 'UPDATED_AT', direction: 'DESC' },
    }),
  ],
};
</script>



// WEBPACK FOOTER //
// OrganizationCombobox.vue?549aa5da